import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import PropertySearchFilterAppResource from "./PropertySearchFilterAppResource";
import WorkspaceOrganizationMemberAppResource from "./WorkspaceOrganizationMemberAppResource";
import UserAppResource from "./UserAppResource";

export const NOTIFICATION_TYPE = {
    EMAIL: 'email',
    TEXT: 'text',
}

export const NOTIFICATION_FREQUENCY = {
    FOUR_HOURS: '240',
}

class SearchAlertSubscriberAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'search-alert-subscriber';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'searches/alerts/subscribers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'propertySearchFilterUuid',
            'projectMemberUuid',
            'inviterProjectMemberUuid',
            'userUuid',
            'enabled',
            'notificationFrequencyInMins',
            'notificationType',
            'propertySearchFilter',
            'projectMember',
            'inviterProjectMember',
            'user',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            propertySearchFilter: PropertySearchFilterAppResource,
            projectMember: WorkspaceOrganizationMemberAppResource,
            inviterProjectMember: WorkspaceOrganizationMemberAppResource,
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            propertySearchFilter: 'property_search_filter_uuid',
            projectMember: 'project_member_uuid',
            inviterProjectMember: 'inviter_project_member_uuid',
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            propertySearchFilterUuid: {
                type: 'string',
                presence: true,
            },
            projectMemberUuid: {
                type: 'string',
                presence: true,
            },
            inviterProjectMemberUuid: {
                type: 'string',
                presence: true,
            },
            userUuid: {
                type: 'string',
            },
            notificationFrequencyInMins: {
                type: 'integer',
            },
            notificationType: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            enabled: {
                type: 'boolean',
            },
        };
    }

}

export default SearchAlertSubscriberAppResource;
